import { Body5, Container, LinkedInLogoButton } from '@ui';
import React from 'react';
import styled from 'styled-components';

const NameWrapper = styled.div`
  * {
    font-size: 24px;
    line-height: 36px;
  }

  text-transform: uppercase;
`;
export const PersonProfileGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  gap: 16px;

  ul {
    padding: 0 0 0 16px;
    margin: 0;
    list-style: circle;

    * {
      font-size: 12px;
      line-height: 16px;
    }
  }
`;

export const HeadshotImage = ({ height, width, src, name }) => {
  return <img src={src} height={height} width={width} />;
};

export const FullSize = ({ imgSrc, linkedInUrl, name, children, ratio, title }) => {
  const size = 280;
  let height = size;
  let width = size;
  if (ratio) {
    width = ratio * size;
  }
  return (
    <Container style={{ width: `${width}px` }}>
      <HeadshotImage width={width} height={height} src={imgSrc} name={name} />
      <Container top={16} row verticallyCenter>
        <NameWrapper>
          <Body5 bold>{name}</Body5>
        </NameWrapper>
        <Container left={24} top={2}>
          <LinkedInLogoButton profileUrl={linkedInUrl} />
        </Container>
      </Container>
      {title && (
        <Container>
          <Body5 bold>{title}</Body5>
        </Container>
      )}

      <Container top={8}>{children}</Container>
    </Container>
  );
};

export const Small = ({ imgSrc, linkedInUrl, name, title, children, ratio }) => {
  const size = 280;
  let height = size;
  let width = size;
  if (ratio) {
    width = ratio * size;
  }
  return (
    <Container fullWidth>
      <HeadshotImage width={width} height={height} src={imgSrc} name={name} />
      <Container top={16}>
        <Body5>
          <b>{name}</b>
        </Body5>
      </Container>
      <Container>
        <LinkedInLogoButton profileUrl={linkedInUrl} />
      </Container>
      {title && (
        <Container>
          <Body5 bold>{title}</Body5>
        </Container>
      )}
      <Container top={8}>{children}</Container>
    </Container>
  );
};

export const PersonProfile = (props) => {
  const { isSmall } = props;
  return isSmall ? <Small {...props} /> : <FullSize {...props} />;
};
